import React, { useContext, useEffect, useState } from "react";
import Footer from "containers/Footer/index.js";
import Header from "containers/Header";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";

import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";

import useSystemsDataHandler from "hooks/useSystemsDataHandler.js";

import ROUTES_PATH from "constants/pages.constant.js";

import ErrorBoundary from "components/ErrorBoundary";
import PageLoading from "components/PageLoading/index.js";
import { SSOContext } from "components/SSOProvider.js";
import { reactPlugin } from "components/Telemetry/AppInsightsRef.jsx";
import WebSocketComponent from "components/WebSocketComponent";

import "../../styles/vendors/style.js";

const RootLayout = props => {
  // window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
  const { loading, isAuthenticated, refresh } = useContext(SSOContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getUserRole } = useSystemsDataHandler();

  const [isLoading, setIsLoading] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    if (!loading) {
      if (isAuthenticated) {
        onUserAuthentication();
      } else {
        console.error("User not authorized, navigating to unauthorized page");
        navigate(ROUTES_PATH.UNUTHORIZED);
      }
    }
  }, [loading, isAuthenticated]);

  const onUserAuthentication = async () => {
    setIsLoading(true);
    const lastVisitedURL = await getUserRole();
    setIsLoading(false);
    if (lastVisitedURL) {
      setIsAuthorized(true);
      navigate(lastVisitedURL);
    } else {
      setIsAuthorized(false);
      console.error("User have no role assigned, navigating to unauthorized page");
      navigate(ROUTES_PATH.UNUTHORIZED);
    }
  };

  const isAuthenticating = () => isAuthenticated !== undefined && !loading && !refresh;

  return (
    <>
      {isAuthenticating() && (
        <AppInsightsContext.Provider value={reactPlugin}>
          <ErrorBoundary>
            <div className="app-main">
              <div className="app-container fixed-drawer fullWidth">
                <div className="app-main-container fullWidth">
                  <div className="app-header">
                    <Header />
                  </div>
                  <div className={"app-main-content-wrapper d-flex"}>{isLoading ? <PageLoading /> : <Outlet />}</div>
                  {(!isAuthenticated || !isAuthorized || isLoading) && <Footer customHeight={"calc(100vh - 110px)"} />}
                </div>
              </div>
              {isAuthenticated && <WebSocketComponent />}
            </div>
          </ErrorBoundary>
        </AppInsightsContext.Provider>
      )}
    </>
  );
};

export default RootLayout;
